import React, { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';

const IsSmallOrMediumScreen: FunctionComponent = ({ children }) => {
  const IsSmallOrMediumScreen = useMediaQuery({ maxWidth: 768 });

  return IsSmallOrMediumScreen ? <>{children}</> : null;
};

export default IsSmallOrMediumScreen;
